"use client";

import { AppError } from "@/components/ui/app-error";

// global-error.tsx must include html and body tags
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <AppError error={error} reset={reset} isGlobal />
      </body>
    </html>
  );
}
